import React from 'react';
import PropTypes from 'prop-types';
import isResizable from '../../../../mixins/resizable';
import update from 'immutability-helper';

// Models
import Industry from '../../../../../models/v2/industry';
import Persona from '../../../../../models/v2/persona';

// Base
import Badge from '../../../base/badge';
import Button from '../../../base/button';
import Placeholder from '../../../base/placeholder';
import Separator from '../../../base/separator';

// Related Components
import LogoutLogo from '../../../agents/subscribe/logout_logo';
import Progress from './progress';

class Industries extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    onSetView: PropTypes.func.isRequired,
  }

  state = {
    persona: {},
    loading: true,
    sending: false,
    industries: [],
    selectedIds: [],
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    const { user } = this.props;
    Promise.all([
      Persona.where({ user_id_eq: user.id }).perPage(1).all(false),
      Industry.where({ user_id_null: true, reviewed_eq: true}).sort('name ASC').all(false),
    ])
      .then((values) => {
        this.setState({
          loading: false,
          persona: values[0][0],
          industries: values[1],
        })
      })
  }

  get isDisabled() {
    const { sending, selectedIds } = this.state;
    return sending || selectedIds.length === 0;
  }

  handleClick = (industryId) => {
    const { selectedIds } = this.state;
    const index = selectedIds.findIndex((id) => id === industryId);
    const action = index > -1 ? { $splice: [[index, 1]] } : { $push: [industryId] };
    const newSelectedIds = update(selectedIds, action);
    this.setState({ selectedIds: newSelectedIds });
  }

  isSelected = (id) => {
    const { selectedIds } = this.state;
    return selectedIds.includes(id);
  }

  handleNext = () => {
    const { onSetView } = this.props;
    const { persona, selectedIds, sending } = this.state;

    if (sending) return;

    this.setState({ sending: true }, () => {
      const data = {
        id: persona.id,
        industry_ids: selectedIds,
      };
      (new Persona(data))
        .save()
        .then((_persona) => {
          onSetView('discovery_source');
        })
        .catch(({ responseJSON }) => {
          this.setState({
            sending: false,
          })
        });
    });
  }

  render() {
    const { loading, industries } = this.state;

    return (
      <React.Fragment>
        <div className='height-60 margin-bottom-70'>
          <LogoutLogo />
        </div>
        <div className='width-560 margin-center relative'>
          <div className='width-400 padding-top-25'>
            <Progress {...{
              value: 2,
              max: 4,
            }} />
          </div>
          <div className='margin-bottom-10 xlg-font semi-bold line-height-26'>Which key industries do you primarily focus on?</div>
          <div className='margin-bottom-10 xsmedm-font'>Select your top picks!</div>
          <Separator className='margin-top-0 margin-bottom-10' />
          <div className='width-520'>
            {
              loading &&
              <Placeholder lines={6} />
            }
            {
              industries.map((industry) => {
                const selected = this.isSelected(industry.id);
                return <Badge {...{
                  key: industry.id,
                  text: industry.name,
                  onClick: () => this.handleClick(industry.id),
                  selected,
                  hoverable: false,
                  selectable: true,
                }} />
              })
            }
            <div className='margin-top-40'>
              <Button {...{
                id: 'continue',
                text: 'Continue',
                onClick: this.handleNext,
                className: 'height-45 med-font vertical-align line-height-45',
                block: true,
                disabled: this.isDisabled,
              }} />
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default isResizable(Industries);
